// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { CommonFunctionService } from "../../service/common-function.service";

@Component({
  selector: "rs-aside",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RSAsideComponent implements OnInit {
  constructor(public router: Router, public cf: CommonFunctionService) {}
  @Output()
  toggleMenu = new EventEmitter();
  @Output()
  navClick = new EventEmitter<any>();

  @Input() isCollapsed: boolean = false; // 接收输入属性
  @Input() customNavClick: boolean = false; // 接收输入属性
  @Input() navList = [];
  @Input() relationStart = [];

  currentNav = "";
  ngOnInit() {
    this.initCurrentNav();
    // 监听路由变化
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // console.log('this.router.url', this.router.url)
        const idx = this.relationStart.findIndex((item) =>
          this.router.url.startsWith(item.url)
        );
        if (idx !== -1) {
          this.currentNav = this.relationStart[idx].target;
        } else {
          this.currentNav = this.router.url;
        }
      });
  }
  initCurrentNav() {
    const idx = this.relationStart.findIndex((item) =>
      this.router.url.startsWith(item.url)
    );
    if (idx !== -1) {
      this.currentNav = this.relationStart[idx].target;
    } else {
      this.currentNav = this.router.url;
    }
  }
  onNavClick(item) {
    if (!this.customNavClick) {
      this.currentNav = item.url;
      this.router.navigate([item.url], { state: { title: item.label } });
      const screenWidth = window.innerWidth;
      if (screenWidth <= 992 && this.isCollapsed) {
        this.toggleMenu.emit(false);
      }
    }
    this.navClick.emit(item);
  }
}
